import { Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { IllustrationModal } from '../IllustrationModal';

import * as S from './style';

export const GiftCollectionSizeModal = ({ isOpen, setIsOpen, ...rest }) => {
  const { t } = useTranslation();

  return (
    <IllustrationModal
      isOpen={isOpen}
      onRequestClose={setIsOpen}
      title={t('giftCollectionSize')}
      secondaryButtonProps={{
        children: t('cancel'),
        onClick: () => setIsOpen(false)
      }}
      content={
        <S.Content>
          <Typography variant="body1Bold">{t('giftCollectionSizeTitle')}</Typography>
          <Typography variant="body2" color="neutral">
            <Trans i18nKey="giftCollectionSizeDesc" components={{ b: <b />, u: <u /> }} />
          </Typography>
        </S.Content>
      }
      {...rest}
    />
  );
};
